// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  font-family: sans-serif;
  margin: 0;
  padding: 0;
  line-height: 1.5;
}

.app-container {
  display: flex;
  flex-direction: column;
  width: min-content;
  margin: auto;
  margin-top: 10vh;
  padding: 10px;
  gap: 10px;
  border: 1px solid grey;
  border-radius: 10px;
}

.weather-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

.title-container {
  text-wrap: nowrap;
}

.current-container {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.currentConditionsDiv {
  display: flex;
  flex-direction: column;
  text-wrap: nowrap;
  align-items: center;
  justify-content: center;
}

.iconDiv {
  margin: auto;
  width: 30%;
}

.tempDiv {
  display: flex;
  font-size: x-large;
  align-items: center;
  gap: 5px;
}

.actualTemp {
  font-size: xx-large;
  justify-self: center;
}

.celcius,
.fahrenheit {
  cursor: pointer;
  font-size: large;
  color: grey;
}

.active {
  font-size: inherit;
  color: inherit;
}

.feelsLike {
  font-size: small;
}

.forecast-container {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
}

.day {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  width: max-content;
  margin: 10px;
  gap: 10px;
}

.forecastIcon {
  margin: auto;
  width: 50px;
}

.highLowDiv,
.dateDiv {
  text-wrap: nowrap;
  font-size: small;
}

.search-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

#search-button {
  width: fit-content;
  margin-top: 5px;
}
`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,SAAS;EACT,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;;EAEE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;;EAEE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB","sourcesContent":["body {\n  font-family: sans-serif;\n  margin: 0;\n  padding: 0;\n  line-height: 1.5;\n}\n\n.app-container {\n  display: flex;\n  flex-direction: column;\n  width: min-content;\n  margin: auto;\n  margin-top: 10vh;\n  padding: 10px;\n  gap: 10px;\n  border: 1px solid grey;\n  border-radius: 10px;\n}\n\n.weather-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 10px;\n}\n\n.title-container {\n  text-wrap: nowrap;\n}\n\n.current-container {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.currentConditionsDiv {\n  display: flex;\n  flex-direction: column;\n  text-wrap: nowrap;\n  align-items: center;\n  justify-content: center;\n}\n\n.iconDiv {\n  margin: auto;\n  width: 30%;\n}\n\n.tempDiv {\n  display: flex;\n  font-size: x-large;\n  align-items: center;\n  gap: 5px;\n}\n\n.actualTemp {\n  font-size: xx-large;\n  justify-self: center;\n}\n\n.celcius,\n.fahrenheit {\n  cursor: pointer;\n  font-size: large;\n  color: grey;\n}\n\n.active {\n  font-size: inherit;\n  color: inherit;\n}\n\n.feelsLike {\n  font-size: small;\n}\n\n.forecast-container {\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr 1fr 1fr;\n}\n\n.day {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: center;\n  width: max-content;\n  margin: 10px;\n  gap: 10px;\n}\n\n.forecastIcon {\n  margin: auto;\n  width: 50px;\n}\n\n.highLowDiv,\n.dateDiv {\n  text-wrap: nowrap;\n  font-size: small;\n}\n\n.search-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n#search-button {\n  width: fit-content;\n  margin-top: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
